tinymce.addI18n("et", {
    "#": "#",
    "Accessibility": "Juurdep\xe4\xe4setavus",
    "Accordion": "Kokkupandav paneel",
    "Accordion body...": "Paneeli sisu...",
    "Accordion summary...": "Paneeli kokkuv\xf5te...",
    "Action": "Tegevus",
    "Activity": "Tegevus",
    "Address": "Aadress",
    "Advanced": "T\xe4psem",
    "Align": "Joonda",
    "Align center": "Joonda keskele",
    "Align left": "Joonda vasakule",
    "Align right": "Joonda paremale",
    "Alignment": "Joondamine",
    "Alignment {0}": "Joondus {0}",
    "All": "K\xf5ik",
    "Alternative description": "Alternatiivne kirjeldus",
    "Alternative source": "Alternatiivne allikas",
    "Alternative source URL": "Alternatiivne allika URL",
    "Anchor": "Ankur",
    "Anchor...": "Ankur ...",
    "Anchors": "Ankrud",
    "Animals and Nature": "Loomad ja loodus",
    "Arrows": "Nooled",
    "B": "S",
    "Background color": "Taustav\xe4rv",
    "Background color {0}": "Taustav\xe4rv {0}",
    "Black": "Must",
    "Block": "Plokk",
    "Block {0}": "Plokk {0}",
    "Blockquote": "Plokktsitaat",
    "Blocks": "Plokid",
    "Blue": "Sinine",
    "Blue component": "Sinine komponent",
    "Body": "Keha",
    "Bold": "Rasvane",
    "Border": "Piir",
    "Border color": "\xc4\xe4rise v\xe4rv",
    "Border style": "Piiri stiil",
    "Border width": "\xc4\xe4rise laius",
    "Bottom": "Alumine",
    "Browse files": "Sirvi faile",
    "Browse for an image": "Sirvi pilte",
    "Browse links": "Sirvi linke",
    "Bullet list": "J\xe4rjestamata loend",
    "Cancel": "Katkesta",
    "Caption": "Alapealkiri",
    "Cell": "Kamber",
    "Cell padding": "Lahtrite polsterdus",
    "Cell properties": "Rakkude omadused",
    "Cell spacing": "Lahtrite vahe",
    "Cell styles": "Lahtri stiilid",
    "Cell type": "Lahtri t\xfc\xfcp",
    "Center": "Keskus",
    "Characters": "Tegelased",
    "Characters (no spaces)": "M\xe4rgid (t\xfchikud puuduvad)",
    "Circle": "Ring",
    "Class": "Klass",
    "Clear formatting": "Puhasta vorming",
    "Close": "Sulge",
    "Code": "Kood",
    "Code sample...": "Koodin\xe4ide ...",
    "Code view": "Koodi vaade",
    "Color Picker": "V\xe4rvivalija",
    "Color swatch": "V\xe4rvivalik",
    "Cols": "Veerud",
    "Column": "Veerg",
    "Column clipboard actions": "Veeru l\xf5ikelaua toimingud",
    "Column group": "Veergude r\xfchm",
    "Column header": "Veeru p\xe4is",
    "Constrain proportions": "Piirake proportsioone",
    "Copy": "Kopeeri",
    "Copy column": "Kopeeri veerg",
    "Copy row": "Kopeeri rida",
    "Could not find the specified string.": "M\xe4\xe4ratud stringi ei leitud.",
    "Could not load emojis": "Emod\u017eeide laadimine eba\xf5nnestus",
    "Count": "Krahv",
    "Currency": "Valuuta",
    "Current window": "Praegune aken",
    "Custom color": "Kohandatud v\xe4rv",
    "Custom...": "Kohandatud ...",
    "Cut": "L\xf5ika",
    "Cut column": "L\xf5ika veerg",
    "Cut row": "L\xf5ika rida",
    "Dark Blue": "Tumesinine",
    "Dark Gray": "Tumehall",
    "Dark Green": "Tumeroheline",
    "Dark Orange": "Tumeoran\u017e",
    "Dark Purple": "Tumelilla",
    "Dark Red": "Tumepunane",
    "Dark Turquoise": "Tume t\xfcrkiissinine",
    "Dark Yellow": "Tumekollane",
    "Dashed": "Katkendlik",
    "Date/time": "Kuup\xe4ev Kellaaeg",
    "Decrease indent": "V\xe4henda taanet",
    "Default": "Vaikimisi",
    "Delete accordion": "Kustuta kokkupandav paneel",
    "Delete column": "Kustuta veerg",
    "Delete row": "Kustuta rida",
    "Delete table": "Kustuta tabel",
    "Dimensions": "M\xf5\xf5tmed",
    "Disc": "Plaat",
    "Div": "Sektsioon",
    "Document": "Dokument",
    "Dotted": "T\xe4piline",
    "Double": "Kahekordne",
    "Drop an image here": "Kukuta pilt siia",
    "Dropped file type is not supported": "See failit\xfc\xfcp ei ole toetatud",
    "Edit": "Muuda",
    "Embed": "Lisa",
    "Emojis": "Emod\u017eid",
    "Emojis...": "Emod\u017eid...",
    "Error": "Viga",
    "Error: Form submit field collision.": "Viga: vormi esitamise v\xe4lja kokkup\xf5rge.",
    "Error: No form element found.": "Viga: vormielementi ei leitud.",
    "Extended Latin": "Laiendatud ladina keel",
    "Failed to initialize plugin: {0}": "Pistikprogrammi l\xe4htestamine eba\xf5nnestus: {0}",
    "Failed to load plugin url: {0}": "Pistikprogrammi URL-i laadimine nurjus: {0}",
    "Failed to load plugin: {0} from url {1}": "Pistikprogrammi laadimine nurjus: {0} URL-ist {1}",
    "Failed to upload image: {0}": "Pildi \xfcleslaadimine eba\xf5nnestus: {0}",
    "File": "Fail",
    "Find": "Leidke",
    "Find (if searchreplace plugin activated)": "Leia (kui otsinguprogrammi plugin on aktiveeritud)",
    "Find and Replace": "Otsi ja asenda",
    "Find and replace...": "Leidke ja asendage ...",
    "Find in selection": "Otsi valikust",
    "Find whole words only": "Leidke ainult terved s\xf5nad",
    "Flags": "Lipud",
    "Focus to contextual toolbar": "Keskenduge kontekstip\xf5hisele t\xf6\xf6riistaribale",
    "Focus to element path": "Keskendumine elemendi rajale",
    "Focus to menubar": "Keskenduge men\xfc\xfcribale",
    "Focus to toolbar": "Keskenduge t\xf6\xf6riistaribale",
    "Font": "Font",
    "Font size {0}": "Kirjat\xfc\xfcbi suurus {0}",
    "Font sizes": "Fondi suurused",
    "Font {0}": "Kirjat\xfc\xfcp {0}",
    "Fonts": "Fondid",
    "Food and Drink": "Toit ja jook",
    "Footer": "Jalus",
    "Format": "Vormindus",
    "Format {0}": "Vormindus {0}",
    "Formats": "Vormingud",
    "Fullscreen": "T\xe4isekraan",
    "G": "R",
    "General": "Kindral",
    "Gray": "Hall",
    "Green": "Roheline",
    "Green component": "Roheline komponent",
    "Groove": "Soon",
    "Handy Shortcuts": "K\xe4ep\xe4rased otseteed",
    "Header": "P\xe4is",
    "Header cell": "P\xe4ise lahter",
    "Heading 1": "Pealkiri 1",
    "Heading 2": "Pealkiri 2",
    "Heading 3": "Pealkiri 3",
    "Heading 4": "Pealkiri 4",
    "Heading 5": "Pealkiri 5",
    "Heading 6": "Pealkiri 6",
    "Headings": "Pealkirjad",
    "Height": "K\xf5rgus",
    "Help": "Abi",
    "Hex color code": "Heksav\xe4rvikood",
    "Hidden": "Peidetud",
    "Horizontal align": "Horisontaalne joondamine",
    "Horizontal line": "Horisontaalne joon",
    "Horizontal space": "Horisontaalne ruum",
    "ID": "ID",
    "ID should start with a letter, followed only by letters, numbers, dashes, dots, colons or underscores.": "ID peab algama t\xe4hega ning sellele v\xf5ivad j\xe4rgneda ainult t\xe4hed, numbrid, kriipsud, punktid, koolonid v\xf5i alakriipsud.",
    "Image is decorative": "Pilt on dekoratiivne",
    "Image list": "Piltide loend",
    "Image title": "Pildi pealkiri",
    "Image...": "Pilt ...",
    "ImageProxy HTTP error: Could not find Image Proxy": "ImageProxy HTTP viga: Image Proxy\u2019t ei leitud",
    "ImageProxy HTTP error: Incorrect Image Proxy URL": "ImageProxy HTTP viga: Vigane Image Proxy\u2019t URL",
    "ImageProxy HTTP error: Rejected request": "ImageProxy HTTP viga: taotlus l\xfckati tagasi",
    "ImageProxy HTTP error: Unknown ImageProxy error": "ImageProxy HTTP viga: Tundmat ImageProxy viga",
    "Increase indent": "Suurenda taanet",
    "Inline": "Reasisene",
    "Insert": "Sisesta",
    "Insert Template": "Sisesta mall",
    "Insert accordion": "Sisesta kokkupandav paneel",
    "Insert column after": "Sisestage veerg p\xe4rast",
    "Insert column before": "Sisestage veerg enne",
    "Insert date/time": "Sisestage kuup\xe4ev / kellaaeg",
    "Insert image": "Sisesta pilt",
    "Insert link (if link plugin activated)": "Sisesta link (kui lingi pistikprogramm on aktiveeritud)",
    "Insert row after": "Lisage rida p\xe4rast",
    "Insert row before": "Sisestage rida enne",
    "Insert table": "Sisesta tabel",
    "Insert template...": "Sisesta mall ...",
    "Insert video": "Sisesta video",
    "Insert/Edit code sample": "Koodin\xe4idise sisestamine / muutmine",
    "Insert/edit image": "Sisesta / muuda pilti",
    "Insert/edit link": "Sisesta / muuda link",
    "Insert/edit media": "Sisestage / muutke meediumit",
    "Insert/edit video": "Video lisamine / muutmine",
    "Inset": "Sisemine",
    "Invalid hex color code: {0}": "Vigane heksav\xe4rvikood: {0}",
    "Invalid input": "Vigane sisend",
    "Italic": "Kaldkiri",
    "Justify": "Joonda r\xf6\xf6pselt",
    "Keyboard Navigation": "Klaviatuuril navigeerimine",
    "Language": "Keel",
    "Learn more...": "Lisateave ...",
    "Left": "Vasakule",
    "Left to right": "Vasakult paremale",
    "Light Blue": "Helesinine",
    "Light Gray": "Helehall",
    "Light Green": "Heleroheline",
    "Light Purple": "Helelilla",
    "Light Red": "Helepunane",
    "Light Yellow": "Helekollane",
    "Line height": "Reak\xf5rgus",
    "Link list": "Lingiloend",
    "Link...": "Link...",
    "List Properties": "Loendi atribuudid",
    "List properties...": "List Properties...",
    "Loading emojis...": "Emod\u017eide laadimine...",
    "Loading...": "Laadimine...",
    "Lower Alpha": "Alam-Alfa",
    "Lower Greek": "Alamkreeka keel",
    "Lower Roman": "Alam-Rooma",
    "Match case": "Tikutoos",
    "Mathematical": "Matemaatiline",
    "Media poster (Image URL)": "Meediaplakat (pildi URL)",
    "Media...": "Meedia ...",
    "Medium Blue": "Keskmine sinine",
    "Medium Gray": "Keskmiselt hall",
    "Medium Purple": "Keskmine lilla",
    "Merge cells": "Lahtrite \xfchendamine",
    "Middle": "Keskmine",
    "Midnight Blue": "Kesk\xf6ine sinine",
    "More...": "Veel ...",
    "Name": "Nimi",
    "Navy Blue": "Merev\xe4e sinine",
    "New document": "Uus dokument",
    "New window": "Uus aken",
    "Next": "J\xe4rgmine",
    "No": "Ei",
    "No alignment": "Joondus puudub",
    "No color": "Pole v\xe4rvi",
    "Nonbreaking space": "Murdmatu ruum",
    "None": "Puudub",
    "Numbered list": "J\xe4rjestatud loend",
    "OR": "V\xd5I",
    "Objects": "Objektid",
    "Ok": "Ok",
    "Open help dialog": "Ava dialoog",
    "Open link": "Ava link",
    "Open link in...": "Ava link saidil ...",
    "Open popup menu for split buttons": "Ava jaotatud nuppude h\xfcpikmen\xfc\xfc",
    "Orange": "Oran\u017e",
    "Outset": "V\xe4limine",
    "Page break": "Lehek\xfcljevahe",
    "Paragraph": "L\xf5ik",
    "Paste": "Kleebi",
    "Paste as text": "Kleebi tekstina",
    "Paste column after": "Kleepige veerg p\xe4rast",
    "Paste column before": "Kleepige veerg enne",
    "Paste is now in plain text mode. Contents will now be pasted as plain text until you toggle this option off.": "Kleepimine on n\xfc\xfcd lihtteksti re\u017eiimis. Sisu kleebitakse lihttekstina seni, kuni Sa selle valiku v\xe4lja l\xfclitad.",
    "Paste or type a link": "Kleepige v\xf5i tippige link",
    "Paste row after": "Kleepige rida p\xe4rast",
    "Paste row before": "Kleepige rida enne",
    "Paste your embed code below:": "Kleepige oma manustamiskood allpool:",
    "People": "Inimesed",
    "Plugins": "Pistikprogrammid",
    "Plugins installed ({0}):": "Installitud pistikprogrammid ({0}):",
    "Powered by {0}": "Toetaja: {0}",
    "Pre": "Eelvormindatud",
    "Preferences": "Eelistused",
    "Preformatted": "Eelvormindaud",
    "Premium plugins:": "Premium pistikprogrammid:",
    "Press the Up and Down arrow keys to resize the editor.": "Redaktori suuruse muutmiseks vajuta \xfcles ja alla nooleklahve.",
    "Press the arrow keys to resize the editor.": "Redaktori suuruse muutmiseks vajuta nooleklahve.",
    "Press {0} for help": "Vajuta {0}, et saada abi",
    "Preview": "Eelvaade",
    "Previous": "Eelmine",
    "Print": "Print",
    "Print...": "Prindi ...",
    "Purple": "Lilla",
    "Quotations": "Tsitaadid",
    "R": "P",
    "Range 0 to 255": "Vahemik 0 kuni 255",
    "Red": "Punane",
    "Red component": "Punane komponent",
    "Redo": "Tee uuesti",
    "Remove": "Eemalda",
    "Remove color": "Eemaldage v\xe4rv",
    "Remove link": "Eemalda link",
    "Replace": "Asenda",
    "Replace all": "Asenda k\xf5ik",
    "Replace with": "Asenda s\xf5naga",
    "Resize": "Suuruse muutmine",
    "Restore last draft": "Taasta viimane mustand",
    "Reveal or hide additional toolbar items": "N\xe4ita v\xf5i peida lisat\xf6\xf6riistad",
    "Rich Text Area": "Vormindatud tekstiala",
    "Rich Text Area. Press ALT-0 for help.": "Rikasteksti ala. Abi saamiseks vajutage ALT-0.",
    "Rich Text Area. Press ALT-F9 for menu. Press ALT-F10 for toolbar. Press ALT-0 for help": "Rikasteksti ala. Men\xfc\xfc avamiseks vajutage ALT-F9. T\xf6\xf6riistariba saamiseks vajutage ALT-F10. VajutageALT-0 abi saamiseks",
    "Ridge": "Hari",
    "Right": "\xd5ige",
    "Right to left": "Paremalt vasakule",
    "Row": "Rida",
    "Row clipboard actions": "Veeru l\xf5ikelaua toimingud",
    "Row group": "R\xfchma r\xfchm",
    "Row header": "Rea p\xe4is",
    "Row properties": "Rea omadused",
    "Row type": "Rea t\xfc\xfcp",
    "Rows": "Read",
    "Save": "Salvesta",
    "Save (if save plugin activated)": "Salvesta (kui pistikprogrammi salvestamine on aktiveeritud)",
    "Scope": "Reguleerimisala",
    "Search": "Otsing",
    "Select all": "Vali k\xf5ik",
    "Select...": "Valige ...",
    "Selection": "Valik",
    "Shortcut": "Otsetee",
    "Show blocks": "N\xe4ita plokke",
    "Show caption": "Kuva pealdis",
    "Show invisible characters": "Kuva n\xe4htamatud t\xe4hem\xe4rgid",
    "Size": "Suurus",
    "Solid": "\xdchtlane",
    "Source": "Allikas",
    "Source code": "L\xe4htekood",
    "Special Character": "Eris\xfcmbol",
    "Special character...": "Eriline tegelane ...",
    "Split cell": "Lahtrite jagamine",
    "Square": "Ruut",
    "Start list at number": "Alusta loendit numbriga",
    "Strikethrough": "L\xe4bikriipsutatud",
    "Style": "Stiil",
    "Subscript": "Alaindeks",
    "Superscript": "\xdclaindeks",
    "Switch to or from fullscreen mode": "L\xfclitumine t\xe4isekraanre\u017eiimile v\xf5i sellest v\xe4lja",
    "Symbols": "S\xfcmbolid",
    "System Font": "S\xfcsteemi font",
    "Table": "Tabel",
    "Table caption": "Tabeli pealkiri",
    "Table properties": "Tabeli omadused",
    "Table styles": "Tabeli stiilid",
    "Template": "Mall",
    "Templates": "Mallid",
    "Text": "Tekst",
    "Text color": "Teksti v\xe4rv",
    "Text color {0}": "Teksti v\xe4rv {0}",
    "Text to display": "Kuvatav tekst",
    "The URL you entered seems to be an email address. Do you want to add the required mailto: prefix?": "Sisestatud URL n\xe4ib olevat e-posti aadress. Kas soovite lisadavajalik mailto: eesliide?",
    "The URL you entered seems to be an external link. Do you want to add the required http:// prefix?": "Teie sisestatud URL n\xe4ib olevat v\xe4line link. Kas soovite lisadavajalik http: // eesliide?",
    "The URL you entered seems to be an external link. Do you want to add the required https:// prefix?": "Sisestatud URL paistab olevat v\xe4line link. Kas soovid lisada vajaliku https:// eesliite?",
    "Title": "Pealkiri",
    "To open the popup, press Shift+Enter": "H\xfcpikakna avamiseks vajutage t\xf5stuklahvi + sisestusklahvi",
    "Toggle accordion": "Kuva/Peida kokkupandav paneel",
    "Tools": "T\xf6\xf6riistad",
    "Top": "\xdcles",
    "Travel and Places": "Reisimine ja kohad",
    "Turquoise": "T\xfcrkiis",
    "Underline": "Allakriipsutatud",
    "Undo": "V\xf5ta tagasi",
    "Upload": "\xdcles laadimine",
    "Uploading image": "Laadin pilti \xfcles",
    "Upper Alpha": "\xdclem-Alfa",
    "Upper Roman": "\xdclemine Rooma keel",
    "Url": "URL",
    "User Defined": "Kasutaja m\xe4\xe4ratud",
    "Valid": "Kehtib",
    "Version": "Versioon",
    "Vertical align": "Vertikaalne joondamine",
    "Vertical space": "Vertikaalne ruum",
    "View": "Vaade",
    "Visual aids": "N\xe4itevahendid",
    "Warn": "Hoiatage",
    "White": "Valge",
    "Width": "Laius",
    "Word count": "S\xf5nade arv",
    "Words": "S\xf5nad",
    "Words: {0}": "S\xf5nad: {0}",
    "Yellow": "Kollane",
    "Yes": "Jah",
    "You are using {0}": "Kasutate seadet {0}",
    "You have unsaved changes are you sure you want to navigate away?": "Teil on salvestamata muudatusi. Kas soovite kindlasti minema navigeerida?",
    "Your browser doesn't support direct access to the clipboard. Please use the Ctrl+X/C/V keyboard shortcuts instead.": "Sinu veebilehitseja ei toeta otsest ligip\xe4\xe4su l\xf5ikelauale. Palun kasuta selle asemel klaviatuuri kiirk\xe4sklusi Ctrl+X/C/V.",
    "alignment": "joondamine",
    "austral sign": "austraalne m\xe4rk",
    "cedi sign": "cedi m\xe4rk",
    "colon sign": "j\xe4mesoole m\xe4rk",
    "cruzeiro sign": "cruzeiro m\xe4rk",
    "currency sign": "v\xe4\xe4ringu m\xe4rk",
    "dollar sign": "dollari m\xe4rk",
    "dong sign": "dongi m\xe4rk",
    "drachma sign": "drahmam\xe4rk",
    "euro-currency sign": "euro v\xe4\xe4ringu m\xe4rk",
    "example": "n\xe4ide",
    "formatting": "vormindamine",
    "french franc sign": "Prantsuse frangi m\xe4rk",
    "german penny symbol": "saksa senti s\xfcmbol",
    "guarani sign": "guarani m\xe4rk",
    "history": "ajalugu",
    "hryvnia sign": "grivna m\xe4rk",
    "indentation": "taane",
    "indian rupee sign": "India ruupia m\xe4rk",
    "kip sign": "kip m\xe4rk",
    "lira sign": "liiri m\xe4rk",
    "livre tournois sign": "elav turniiri m\xe4rk",
    "manat sign": "manati m\xe4rk",
    "mill sign": "veskim\xe4rk",
    "naira sign": "naira m\xe4rk",
    "new sheqel sign": "uus \u0161ekeli m\xe4rk",
    "nordic mark sign": "p\xf5hjam\xe4rgi m\xe4rk",
    "peseta sign": "peseta m\xe4rk",
    "peso sign": "peeso m\xe4rk",
    "ruble sign": "rubla m\xe4rk",
    "rupee sign": "ruupia m\xe4rk",
    "spesmilo sign": "spesmilo m\xe4rk",
    "styles": "stiilid",
    "tenge sign": "tenge m\xe4rk",
    "tugrik sign": "tugriku m\xe4rk",
    "turkish lira sign": "t\xfcrgi liiri m\xe4rk",
    "won sign": "v\xf5itis m\xe4rgi",
    "yen character": "jeeni tegelaskuju",
    "yen/yuan character variant one": "jeeni / j\xfcaani t\xe4hem\xe4rgi variant \xfcks",
    "yuan character": "j\xfcaani tegelaskuju",
    "yuan character, in hong kong and taiwan": "j\xfcaani tegelane, Hongkongis ja Taiwanis",
    "{0} characters": "{0} t\xe4hem\xe4rki",
    "{0} columns, {1} rows": "{0} veergu, {1} rida",
    "{0} words": "{0} s\xf5na"
});